module.exports = __webpack_public_path__ + "static/img/course.433d3f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/course.jpg
// module id = 9zBP
// module chunks = 0